import { data as order } from './orders'
import { data as finance } from './finance'
import { data as auth } from './auth'
// ## new import here ##

export const gaEvents = {
  order,
  finance,
  auth,
  // ## new event here ##
}
